import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bidi-user-file',
  templateUrl: './user-file.component.html',
  styleUrls: ['./user-file.component.scss']
})
export class UserFileComponent implements OnInit {

  @Output() panelState: EventEmitter<any> = new EventEmitter;
  userState = false;

  constructor() { }

  ngOnInit() {
  }

  closeUserFile() {
    this.panelState.emit({state: this.userState, panel: 'Ficha'});
  }
}
